import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

@Component({
  selector: 'sellions-quiz',
  templateUrl: 'sellions-quiz.html'
})
export class SellionsQuizComponent implements OnInit {
  @Input() quiz;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  currentDate = new Date();

  constructor() {
  }

  ngOnInit() {
    this.quiz.isExpired = new Date(this.quiz.expirationDate) < this.currentDate;
  }

  onQuizSelected() {
    this.onSelect.emit(this.quiz.id);
  }
}



// WEBPACK FOOTER //
// ./src/modules/quizzes/components/sellions-quiz/sellions-quiz.ts